import { $loading } from "various-ui";

/**@name 用户意图（突变） */
export const mutation = (id: string, keyword?: string) => {
    if (!keyword?.trim()) open(routerResolve({ name: "BioVariantResult", params: { id: id } }).href, "_blank");
    else {
        $loading.open();
        api.frontend("/api/mutations/identify", {
            data: { keyword: keyword, id: id },
            hidden: true,
            method: "POST",
            error: () => open(routerResolve({ name: "BioVariantResult", params: { id: id } }).href, "_blank"),
            finally: () => $loading.close(),
            success: (mutation) => {
                if (!mutation) open(routerResolve({ name: "BioVariantResult", params: { id: id } }).href, "_blank");
                else {
                    open(routerResolve({ name: "BioVariantResult", params: { id: id }, query: { keyword: mutation } }).href, "_blank");
                }
            },
        });
    }
};
